import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
/* global gtag */

const affiliateSignupUrl = "https://easyimagetotext.lemonsqueezy.com/affiliates";

function Navbar({ setShowFeedbackPopup, isMobileMenuOpen, setIsMobileMenuOpen, isNewUser=false }){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();
    isShowConsole && console.log("Current Path:", location.pathname); 

    const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

    const openUserAccountPage = e => {
        try{
            navigate(`/user-account`);
        }catch(err){
            isShowConsole && console.error('error in openUserAccountPage method: ', err);
        }
    }
    
    const openPricingPage = e => {
        //event tracker
            gtag('event', 'pricing_clicked', {
                event_category: 'Button',
                event_label: 'Pricing'
            });
        //
        try{
            navigate(`/sheets-extension-pricing`);
        }catch(err){
            isShowConsole && console.error('error in openPricingPage method in table ocr: ', err);
        }
    }

    const openAffiliatePage = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
            navigate(`/affiliate`);
        }catch(err){
            isShowConsole && console.error('error in openAffiliatePage method: ', err);
        }
    }

    const initiateAffiliateSignup = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
            window.open(affiliateSignupUrl, '_blank', 'noopener,noreferrer');
        }catch(err){
            console.log('error in initiateAffiliateSignup method: ', err);
            
        }
    }

    const handleHelpClick = e => {
        try{
            navigate(`/sheets-extension-contact-us`);
        }catch(err){
            isShowConsole && console.error('error in handleHelpClick method in Table OCR: ', err);
        }
    }

    const handleBlogsClick = e => {
        try{
            navigate(`/sheets-extension-blogs`);
        }catch(err){
            isShowConsole && console.error('error in handleBlogsClick method in Table OCR: ', err);
        }
    }

    const handleAffiliateClick = e => {
        try{
            navigate(`/sheets-extension-affiliate`);
        }catch(err){
            isShowConsole && console.error('error in handleAffiliateClick method in Table OCR: ', err);
        }
    }

    const handleFAQclick = e => {
        try{
            navigate(`/sheets-extension-faq`);
        }catch(err){
            isShowConsole && console.error('error in handleHelpClick method: ', err);
        }
    }

    const isHomeScreen = location.pathname.includes('yt-comment-filter');
    isShowConsole && console.log('is home screen: ', isHomeScreen);

    return(
        <>
            <div className="navbarCont">
                <div className="logoDiv">
                    <div className='logoImg'>
                        <img style={{width: '584px'}} src={'/pdf2sheets logo.png'} alt='app logo' />
                    </div>
                    <div className='logoTxt'><span style={{textTransform: 'none'}}>Convert PDF to Google Sheets™</span></div>
                </div>
                { 
                    <div className="navigationDiv">
                        <div className='newUserAffiliate' onClick={handleAffiliateClick}>Share & Earn</div>
                        {/* <div><a href='#use-cases'>Use Cases</a></div> */}
                        {/* <div><a href='#why-this-app'>Why this App</a></div> */}
                        {/* <div><a href='#how-it-works'>How It Works</a></div> */}
                        <div className='helpBtn' onClick={handleFAQclick}>FAQs</div>
                        {/* <div className='helpBtn' onClick={handleHelpClick}>{isNewUser ? "Contact Us" : "Help ?"}</div> */}
                        <div className='helpBtn'><Link to="/sheets-extension-blogs">Blogs</Link></div>
                        {isNewUser && <div className='newUserPricing' onClick={openPricingPage}>Pricing</div>}
                    </div>
                }
            </div>
        </>
    )
}

export default Navbar;